import templateUrl from './page-not-found.html';

export const pageNotFoundComponent = {
    templateUrl,

    controller: class PageNotFoundComponent {
        constructor($state) {
            'ngInject';

            this.$state = $state;
        }
        
        goHome() {
            this.$state.go('DynamicMenus', {
                url: 'home'
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/page-not-found/page-not-found.component.js